// Login.jsx
// Modern, professional login component with enhanced UX

import React from 'react';
import { styles } from './styles';
import useLogin from './useLogin';
import LoginForm from './LoginForm';
import ErrorDisplay from './ErrorDisplay';
import UnverifiedEmailSection from './UnverifiedEmailSection';
import SignupPrompt from './SignupPrompt';
import { UniversityIcon } from '../../components/Icons';
import './Login.css';

const Login = () => {
  const {
    email,
    setEmail,
    password,
    setPassword,
    unverifiedUser,
    errorMsg,
    cooldown,
    loggingIn,
    handleLogin,
    resendVerification,
    navigateToSignup
  } = useLogin();

  // Detect Brave browser
  const [isBrave, setIsBrave] = React.useState(false);
  
  React.useEffect(() => {
    if (navigator.brave && typeof navigator.brave.isBrave === 'function') {
      navigator.brave.isBrave().then((result) => {
        setIsBrave(result);
      });
    }
  }, []);

  return (
    <div style={styles.container} className="login-container">
      {/* Background decoration for modern aesthetic */}
      <div style={styles.backgroundDecoration}></div>
      
      {/* Main login card with professional design */}
      <div style={styles.loginCard} className="login-card">
        {/* Header with ISU branding and modern typography */}
        <div style={styles.header}>
          <div style={styles.brandSection}>
            <div style={styles.brandIcon}>
              <UniversityIcon size={24} color="white" />
            </div>
            <h1 style={styles.brandText} className="brand-text">Redbird Markets</h1>
          </div>
          <h2 style={styles.title} className="login-title">Welcome Back</h2>
          <p style={styles.subtitle} className="login-subtitle">
            Sign in to your Illinois State University marketplace account to continue buying and selling with fellow Redbirds.
          </p>
        </div>
        
        {/* Brave Shields Warning */}
        {isBrave && (
          <div style={{
            background: '#fff3cd',
            border: '1px solid #ffc107',
            borderRadius: '8px',
            padding: '12px 16px',
            marginBottom: '16px',
            fontSize: '14px',
            color: '#856404'
          }}>
            <strong>⚠️ Brave Browser Detected:</strong> If you experience login issues, please click the lion icon in your address bar and disable Shields for this site, or use a different browser.
          </div>
        )}
        
        {/* Login form section with modern inputs */}
        <div style={styles.formSection}>
          <LoginForm
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            onSubmit={handleLogin}
            loggingIn={loggingIn}
          />
        </div>
        
        {/* Error display with modern alert design */}
        <ErrorDisplay errorMsg={errorMsg} />
        
        {/* Unverified email section with professional warning design */}
        <UnverifiedEmailSection
          unverifiedUser={unverifiedUser}
          onResendVerification={resendVerification}
          cooldown={cooldown}
        />
        
        {/* Signup prompt with call-to-action design */}
        <SignupPrompt onNavigateToSignup={navigateToSignup} />
      </div>
    </div>
  );
};

export default Login;